module.exports = __webpack_public_path__ + "img/SKMJ_plan1.4f6963c9.png";